function countWords(poems, rowType, columnValues, columnType, withDuplicates) {
  const counts = new Map();
  poems.forEach(poem => {
    let rowValues = poem[`${rowType}s`];
    if (!withDuplicates) rowValues = [...new Set(rowValues)];
    rowValues.forEach(rowValue => {
      if (!counts.has(rowValue)) {
        counts.set(
          rowValue,
          new Map(
            ["_all", ...columnValues].map(columnValue => [columnValue, 0])
          )
        );
      }
      const rowCounts = counts.get(rowValue);
      ["_all", ...poem[`${columnType}s`]].forEach(columnValue => {
        if (rowCounts.has(columnValue)) {
          rowCounts.set(columnValue, rowCounts.get(columnValue) + 1);
        }
      });
    });
  });
  const wordsCount = [...counts.entries()].map(([rowValue, rowCounts]) => {
    const d = { key: rowValue };
    [...rowCounts.entries()].map(([columnValue, count]) => {
      d[columnValue] = count;
    });
    return d;
  });

  return wordsCount;
}

export { countWords };
